import React, { useEffect } from "react"
import { track } from "../analytics/mixpanel"
import { ErrorBoundary } from "./ErrorBoundary"
import { ThemeProvider } from "./landing/ThemeProvider"
import { LangProvider } from "./landing/i18n/LangContext"
import { SiteNav } from "./landing/SiteNav"
import { HeroSection } from "./landing/HeroSection"
import { StatsSection } from "./landing/StatsSection"
import { GrowthLoopSection } from "./landing/GrowthLoopSection"
import { FeaturesSection } from "./landing/FeaturesSection"
import { UpcomingSection } from "./landing/UpcomingSection"
import { FinalCta } from "./landing/FinalCta"
import { SiteFooter } from "./landing/SiteFooter"

export default function App({ logoUrl, signedIn }) {
  useEffect(() => {
    track("Landing Page Viewed", { path: window.location.pathname })
  }, [])

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <LangProvider>
          <div className="min-h-screen bg-white dark:bg-gray-950 antialiased">
            <SiteNav logoUrl={logoUrl} signedIn={signedIn} />
            <main>
              <HeroSection signedIn={signedIn} />
              <StatsSection />
              <GrowthLoopSection />
              <FeaturesSection />
              <UpcomingSection />
              <FinalCta />
            </main>
            <SiteFooter logoUrl={logoUrl} />
          </div>
        </LangProvider>
      </ThemeProvider>
    </ErrorBoundary>
  )
}
